import { FakeLodash } from "../coreutil/FakeLodash";
export var SettingsNormalization;
(function (SettingsNormalization) {
    SettingsNormalization.bool = (def) => (old) => typeof old == "boolean" ? old : def;
    SettingsNormalization.number = (def) => (old) => typeof old == "number" ? old : def;
    function clamp(lowest, highest) {
        return (old) => FakeLodash.clamp(old, lowest, highest);
    }
    SettingsNormalization.clamp = clamp;
    SettingsNormalization.str = (def) => (old) => old ?? def;
    function normaliz(functions) {
        return old => {
            if (!old)
                old = {};
            for (const key of Object.keys(functions)) {
                const f = functions[key];
                old[key] = f(old[key]);
            }
            return old;
        };
    }
    SettingsNormalization.normaliz = normaliz;
})(SettingsNormalization || (SettingsNormalization = {}));
